<template>
  <div class="jc-cell-wrapper" :class="[wrapperClass,
     {'jc-cell-hidden-last-border': hideLastItemBorder},
     {'jc-cell-collapse': collapse},
     {'jc-cell-clickable': clickable && !collapse}]"
     @click.stop="handleCellClick">
    <div class="jc-cell"
     :class="[
     verticleAlign ? `jc-cell-vericle-align-${verticleAlign}` : '',
     {'jc-cell-nowrap': !wrap}
     ]">
        <div class="jc-cell-icon" v-if="icon"><i :class="icon"></i></div>
        <div class="jc-cell-body" :class="{'no-icon': !icon}">
          <slot><div class="jc-cell-body-title"
          :class="[`align-${titleAlign}`]"
          v-if="title">{{title}}</div></slot>
          <div class="jc-cell-body-sub-title"
          :class="[`align-${subTitleAlign}`]"
          v-if="subTitle">{{subTitle}}</div>
        </div>
        <div class="jc-cell-append" v-if="$slots.append || extra"><span class="extra">{{extra}}</span><slot name="append"/></div>
        <slot name="append-icon"/>
        <i v-if="arrow || collapse" class="van-icon van-icon-arrow arrow-icon" :class="[` van-cell__${arrowDirection}-icon`, {active: collapse && !isCollapse}]"></i>
    </div>
    <collapse-transition>
     <div v-show="collapse && $slots.collapse && !isCollapse" class="jc-cell-collapse-content"><slot name="collapse"/></div>
    </collapse-transition>
  </div>
</template>

<script>
import routerLink from '@/utils/mixins/router-link'
export default {
  name: 'jc-cell',
  mixins: [routerLink],
  props: {
    arrowDirection: { // 箭头方向
      type: String,
      default: 'right'
    },
    arrow: Boolean, // 是否有箭头
    icon: String, // 图标 可以使用字体图标或背景图
    clickable: Boolean, // 是否可以点击
    title: String, // 标题
    subTitle: String, // 副标题 位于标题下方
    extra: String,
    verticleAlign: String, // 主体部分和追加部分的对齐方式 middle（默认middle）、top bottom
    titleAlign: {
      type: String,
      default: 'left'
    }, // 标题对齐方式
    subTitleAlign: {
      type: String,
      default: 'left'
    }, // 副标题对齐方式
    wrap: Boolean, // 是否换行
    hideLastItemBorder: {
      type: Boolean,
      default: true
    },
    wrapperClass: String,
    isLink: Boolean,
    collapse: Boolean
  },
  data () {
    return {
      isCollapse: true
    }
  },
  methods: {
    handleCellClick (e) {
      if (this.isLink) {
        this.routerLink()
      } else {
        if (this.collapse) {
          this.isCollapse = !this.isCollapse
        }
        this.$emit('click', e)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variable.scss';
@import '@/assets/scss/mixins.scss';
.cell-list-item {
  padding: 0 20px;
  // padding: 12px 15px;
}
.jc-cell-wrapper {
  &.jc-cell-hidden-last-border {
    &:last-child {
      .jc-cell::after {
        display: none!important;
      }
    }
  }
  &.jc-cell-clickable:active {
    background: #e8e8e8;
  }
  &.jc-field {
    .jc-cell-append {
      max-width: 200px;
      font-size: 24px;
    }
    .jc-cell-body {
      margin-left: 0px!important;
    }
  }
  &.jc-cell-collapse { // 折叠单元格
    .arrow-icon {
      transition: .3s transform;
      &.active {
        transform: rotate(90deg);
      }
    }
    .jc-cell-wrapper {
      .jc-cell {
        padding-left: 0;
        padding-right: 0; 
      }
    }
  }
}
.jc-cell {
  width: 100%;
  // height: 70px;
  // padding: 10px 20px;
  padding: 12px 15px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  &::after {
    @include border-bottom-1px(#e9eaec);
  }
  &-icon {
    min-width: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-body {
    margin-left: 40px;
    flex: 1;
    // height: 24px;
    // line-height: 24px;
    display: flex;
    min-height: 60px; // 上下10 + 50 每个cell不可能一样高
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &.no-icon {
      margin-left: 6px;
    }
    // TODO 不应该放这里
    .cell-input {
      width: 100%;
      font-size: 24px;
      padding-left: 35px;
      padding-right: 20px;
      outline: none;
      opacity: 1!important;
      border: none;
      line-height: normal;
      background: transparent;
      color: #606060!important;
      &::-webkit-input-placeholder {
        color: #bbb;
      }
    }
    &-title {
      width: 100%;
      font-size: 24px;
      &.align-center {
        text-align: center;
      }
      &.align-left {
        text-align: left;
      }
      &.align-right {
        text-align: right;
      }
    }
    &-sub-title {
      width: 100%;
      &.align-center {
        text-align: center;
      }
      &.align-left {
        text-align: left;
      }
      &.align-right {
        text-align: right;
      }
    }
  }
  &.jc-cell-vericle-align-middle {
    align-items: center;
  }
  &.jc-cell-vericle-align-top {
    align-items: flex-start;
  }
  &.jc-cell-vericle-align-bottom {
    align-items: flex-end;
  }
  &.jc-cell-nowrap {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  i {
    color: #b2b2b3;
  }
  &-append {
    flex-basis: 60%;
    text-align: right;
    display: flex;
    align-items: center;
    white-space: normal;
    .extra {
      flex: 1;
      font-size: 24px;
      line-height: 1;
      color: #bbb;
      align-self: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cell/cell.vue